import { Outlet, Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";


export const PrivateRoute = ({ children, permissions = null, redirectTo = "/" }) => {

  let location = useLocation();

  const accessToken = localStorage.getItem('accessToken');
  const user = JSON.parse(localStorage.getItem('user'));

  if (accessToken === null)
    return <Navigate to={redirectTo} state={{ from: location }} replace />

  if (user?.role === "admin")
    return children

  if (permissions) {
    const canAccess = user.permissions.some(user_permissions => permissions.includes(user_permissions));
    if (!canAccess) {
      return <Navigate to={redirectTo} state={{ from: location }} replace />
    }
  }

  return children
}

